var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "din-settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-113.000000, -869.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "din-settings",
    transform: "translate(113.000000, 869.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 464,
    cy: 469,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skis_line_53",
    transform: "translate(100.000000, 119.000000)",
    stroke: "#000000",
    strokeWidth: 19.2307692
  }, /*#__PURE__*/React.createElement("line", {
    x1: 105.769231,
    y1: 317.625,
    x2: 163.461538,
    y2: 317.625,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.769231,
    y1: 279.125,
    x2: 221.153846,
    y2: 279.125,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.4615385,
    y1: 105.875,
    x2: 38.4615385,
    y2: 462,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 423.5,
    x2: 76.9230769,
    y2: 423.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.538462,
    y1: 317.625,
    x2: 278.846154,
    y2: 317.625,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.230769,
    y1: 279.125,
    x2: 278.846154,
    y2: 279.125,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.307692,19.25 L442.307692,96.25 C442.307692,101.563 446.615385,105.875 451.923077,105.875 L471.153846,105.875 C476.461538,105.875 480.769231,101.563 480.769231,96.25 L480.769231,19.25 C480.769231,8.614375 472.163462,0 461.538462,0 C450.913462,0 442.307692,8.614375 442.307692,19.25 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.538462,
    y1: 105.875,
    x2: 461.538462,
    y2: 462,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 423.5,
    x2: 423.076923,
    y2: 423.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.153846,163.625 L221.153846,125.125 C221.153846,56.0175 195.326923,0 163.461538,0 C131.596154,0 105.769231,56.0175 105.769231,125.125 L105.769231,413.875 C105.769231,435.136625 122.990385,452.375 144.230769,452.375 L182.692308,452.375 C203.932692,452.375 221.153846,435.136625 221.153846,413.875 L221.153846,182.875",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.846154,221.375 L278.846154,125.125 C278.846154,56.0175 304.673077,0 336.538462,0 C368.403846,0 394.230769,56.0175 394.230769,125.125 L394.230769,413.875 C394.230769,435.136625 377.009615,452.375 355.769231,452.375 L317.307692,452.375 C296.067308,452.375 278.846154,435.136625 278.846154,413.875 L278.846154,240.625",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6923077,28.875 L57.6923077,19.25 C57.6923077,8.614375 49.0865385,0 38.4615385,0 C27.8365385,0 19.2307692,8.614375 19.2307692,19.25 L19.2307692,96.25 C19.2307692,101.563 23.5384615,105.875 28.8461538,105.875 L48.0769231,105.875 C53.3846154,105.875 57.6923077,101.563 57.6923077,96.25 L57.6923077,48.125",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.b776bb36108b3a6b4e03173a2d4789ec.svg";
export { ForwardRef as ReactComponent };